export default __webpack_public_path__ + "static/media/Jubilat-BoldItalic.d89981f8.otf";